import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizTitle from "../shared/QuizTitle";
import QuizOptions from "../shared/QuizOptions";
import QuizOption from "../shared/QuizOption";
import { getQuizOptions } from "../../utils/quizOptions";

const Step4 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("friendAI");

  const handleOptionClick = (value) => {
    onAnswer("friendAI", value);
  };

  return (
    <div className="quizContentWrapper">
      <QuizContent>
        <QuizTitle>
          What would you like your AI friend to help you with?
        </QuizTitle>
        <QuizOptions>
          {quizOptions.map((option) => (
            <QuizOption
              key={option.value}
              value={option.value}
              name="friendAI"
              onClick={handleOptionClick}
            >
              <div>
                <p>
                  <strong>{option.text}</strong>
                </p>
              </div>
            </QuizOption>
          ))}
        </QuizOptions>
      </QuizContent>
    </div>
  );
};

export default Step4;
